"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.formatter = exports.calculateSecondPaymentDays = exports.selectPaymentDay = exports.handleCreditBuilderSetReinforcementMessage = exports.handleSetReinforcementMessage = exports.filterDays = exports.calculatePaymentDays = exports.filterPaymentDays = exports.calculatePaymentDaysWithOrdinal = void 0;
var date_1 = require("./date");
var domain_1 = require("@genoa/domain");
/**
 * @deprecated Use calculatePaymentDays without ordinal instead
 */
function calculatePaymentDaysWithOrdinal(startDay, endDay) {
    return Array.from({ length: endDay - startDay + 1 }, function (_, index) {
        var day = index + startDay;
        var ordinalSuffix = (0, date_1.ordinalSuffixFor)(day);
        var ordinal = ordinalSuffix.slice(-2);
        return { day: day, ordinal: ordinal };
    });
}
exports.calculatePaymentDaysWithOrdinal = calculatePaymentDaysWithOrdinal;
/**
 * @deprecated use filterDays for SLC
 */
function filterPaymentDays(days, comparisonDay, isAfter) {
    if (isAfter === void 0) { isAfter = true; }
    return days.filter(function (_a) {
        var day = _a.day;
        return (isAfter ? day >= comparisonDay.day : day <= comparisonDay.day);
    });
}
exports.filterPaymentDays = filterPaymentDays;
var calculatePaymentDays = function (startDay, endDay) {
    var days = [];
    if (startDay < endDay) {
        for (var day = startDay; day <= endDay; day++) {
            days.push(day);
        }
    }
    else {
        for (var day = startDay; day <= 31; day++) {
            days.push(day);
        }
        for (var day = 1; day <= endDay; day++) {
            days.push(day);
        }
    }
    return days;
};
exports.calculatePaymentDays = calculatePaymentDays;
var filterDays = function (days, comparisonDay, isAfter) {
    if (isAfter === void 0) { isAfter = true; }
    return days.filter(function (day) { return (isAfter ? day >= comparisonDay : day <= comparisonDay); });
};
exports.filterDays = filterDays;
var handleSetReinforcementMessage = function (scheduleDay, daysSelected) {
    var firstDay = daysSelected.firstDay, secondDay = daysSelected.secondDay;
    if (secondDay && firstDay) {
        if (secondDay >= firstDay + 8) {
            return domain_1.ReinforcementMessage.SECOND_POSITIVE;
        }
        else if (secondDay <= firstDay + 7) {
            return domain_1.ReinforcementMessage.SECOND_NEGATIVE;
        }
    }
    else if (firstDay) {
        if (firstDay <= scheduleDay - 8) {
            return domain_1.ReinforcementMessage.FIRST_POSITIVE;
        }
        else if (firstDay >= scheduleDay - 7) {
            return domain_1.ReinforcementMessage.FIRST_NEGATIVE;
        }
    }
    return undefined;
};
exports.handleSetReinforcementMessage = handleSetReinforcementMessage;
var handleCreditBuilderSetReinforcementMessage = function (scheduleDay, daySelected) {
    if (daySelected) {
        if (daySelected <= scheduleDay - 8) {
            return domain_1.ReinforcementMessage.FIRST_POSITIVE;
        }
        else if (daySelected >= scheduleDay - 7) {
            return domain_1.ReinforcementMessage.FIRST_NEGATIVE;
        }
    }
    return undefined;
};
exports.handleCreditBuilderSetReinforcementMessage = handleCreditBuilderSetReinforcementMessage;
var selectPaymentDay = function (day, paymentToUpdate, setDaysSelected) {
    setDaysSelected(function (currentDays) {
        var _a, _b;
        var shouldRemoveSecondDay = paymentToUpdate === domain_1.PaymentDays.FIRST_DAY &&
            currentDays[domain_1.PaymentDays.SECOND_DAY] &&
            day > currentDays[domain_1.PaymentDays.SECOND_DAY];
        return __assign(__assign(__assign({}, currentDays), (_a = {}, _a[paymentToUpdate] = day, _a)), (shouldRemoveSecondDay && (_b = {}, _b[domain_1.PaymentDays.SECOND_DAY] = undefined, _b)));
    });
};
exports.selectPaymentDay = selectPaymentDay;
var calculateSecondPaymentDays = function (schedule) {
    if (schedule.length === 4) {
        var startDay = schedule[2], endDay = schedule[3];
        return (0, exports.calculatePaymentDays)(startDay, endDay);
    }
    else if (schedule.length > 0) {
        var startDay = schedule[0], endDay = schedule[1];
        return (0, exports.calculatePaymentDays)(startDay, endDay);
    }
    return [];
};
exports.calculateSecondPaymentDays = calculateSecondPaymentDays;
var formatter = function (day) {
    var ordinalSuffix = (0, date_1.ordinalSuffixFor)(day);
    var ordinal = ordinalSuffix.slice(-2);
    return "".concat(day).concat(ordinal, " of the month");
};
exports.formatter = formatter;
